<wiz-vgroup class="basicInput" width="100%">
  <!-- <wiz-hgroup  width="100%" height="100%" (click)="showHidePop()" gap="0"> -->
      <wiz-text-input
      #content
      [manageModel] = false
      [wizShowLabel]="false"
      [wizMaxChars]="100"
      [wizShowClearButton]="false"
      readonly="true"
      width="100%"
      [wizRightIcon]="niceIcon"></wiz-text-input>
  <!-- </wiz-hgroup> -->
</wiz-vgroup>
